import RequestForm from "../model/request-form"
import {RequestFormFieldType} from "../const/const"
import FormManager from "../../../../core/gd-form/common/form-manager"
import {FieldType} from "../../../../core/fields3/field-type"
import {MandatoryFieldsIds} from "./get-mandatory-form-fields";

const debug = false
// const debug = "createFormViewFormManager"

export default function createFormViewFormManager(requestForm:RequestForm, onSubmit:any) {
    const formStructure: any = {
        fields  : {},
        onSubmit: onSubmit
    }

    let fieldNumber = 0

    _.map(requestForm.settings.fields, (requestFormField)=>{
        let fieldId
        let label, isRequired, validator

        if (requestFormField.field) {
            switch (requestFormField.type) {
                case RequestFormFieldType.TASK:
                    fieldId     = requestFormField.field.fieldId
                    label       = requestFormField.label
                    isRequired  = requestFormField.isRequired
                    break

                case RequestFormFieldType.FORM:

                    fieldId = "f-{0}".f(++fieldNumber)
                    requestFormField.field.fieldId = fieldId

                    label       = requestFormField.label
                    isRequired  = requestFormField.isRequired
                    break
            }

            switch (requestFormField.field.type) {
                case FieldType.EMAIL:
                    validator = (val:any)=>{

                        // empty email is OK unless required
                        if (!val) return true

                        const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                        const isValid = re.test(val);
                        if (!isValid) {
                            return "Email address is incorrect";
                        }
                        return true
                    }
                    break
            }
        }

        // deleted custom fields do not have fieldId and should be skipped
        if (fieldId) {
            formStructure.fields[fieldId] = {
                type        : 'input',
                isRequired  : isRequired,
                label       : label,
                validator   : validator
            }
        }
    })

    debug && console.log(debug, 'process', formStructure)

    return new FormManager(formStructure, {})
}